/*
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2023-12-27 11:04:36
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2023-12-27 11:04:53
 * @FilePath: \合联\oms\src\api\analysis\missingTrackMonitor.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/report/tracker/monitor'

export const apis = buildApi({
  get: [name + '&list',],
  post: [name + '/save', name + '/delete/:id&del', '/report/tracker/updateMonitor']
})